<script setup lang="ts">
  import { useInitStore } from './store/initStore'

  const initStore = useInitStore()
  initStore.load()
</script>

<template>
  <router-view />
</template>
